import {faBroom} from "@fortawesome/pro-solid-svg-icons/faBroom";
import {MessageCentreUrlSlugs} from "@twigsby/client-data";
import {
    Button,
    ButtonSize,
    FlexAlign,
    FlexGap,
    StackHorizontal,
    Tooltip,
    useTranslation
} from "@twigsby/frontend-framework";
import React from "react";
import {ActiveFilterEntries} from "./ActiveFilterEntries";
import {ActiveFilterPillsType, GenericFilterType} from "./FilterTypes";

const ActiveFilterPills = (props: ActiveFilterPillsType) => {
    const { t } = useTranslation();

    return (
        <>
            {!props.hideLabel && (
                <small className={'sub-heading'}>Active Filters:</small>
            )}

            <StackHorizontal gap={FlexGap.ExtraSmall} align={FlexAlign.Center}>
                <ActiveFilterEntries
                    activeFilters={props.activeFilters as Array<GenericFilterType>}
                    removeFilterCallback={(key) => props.removeFilterCallback(key as keyof MessageCentreUrlSlugs)}
                />
                {Object.keys(props.activeFilters).length > 1 && (
                    <Tooltip content={t('actions.clearFilters')}>
                        <Button
                            title={t('actions.clearFilters')}
                            icon={faBroom}
                            iconOnly={true}
                            size={ButtonSize.Small}
                            onClick={props.clearFiltersCallback}
                        />
                    </Tooltip>
                )}
            </StackHorizontal>
        </>
    )
}

export { ActiveFilterPills };
